export const getTokens = (ownerId: string) => {
  return [
    localStorage.getItem(`_hp_mbe_${ownerId}_access_token`),
    localStorage.getItem(`_hp_mbe_${ownerId}_refresh_token`),
  ]
}
